export default "__VITE_ASSET__PchdTri___"